import React from 'react';
import { Button, Modal, Toast, Badge, Icon } from 'antd-mobile';
import {post} from '../../utils/request';
import cookies from 'js-cookie';
import api from '../index/api';
import { getUrlParam, href } from '../../utils/util';

import { wxfx } from '../../utils/wxfx.js';

import './index.less';
// import { div } from 'react/lib/ReactDOMFactories';

class informationCollectionListEquipment extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            statictisData: {},
            urlOps:{},
        };
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.cssText = 'background: #F4F4F5 !important';
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                console.log(this.state.urlOps);
                if(ops.app_stoken && ops.app_stoken != 'null'){ 
                    post({
                        url: api.selectCollectedPersonalInfoList + '?app_stoken=' + this.state.urlOps.app_stoken,
                        data: {}
                    }).then((res) => {
                        if(res.result === 'success'){
                            this.setState({
                                statictisData: res.data
                            }),()=>{
                                // console.log(this.statictisData);
                            }
                        }else{
                            Toast.info(res.msg,1);
                        }
                    }, (res)=>{
                        Toast.info('获取统计数据失败',1);
                    });
                }
                
                
            });
            
        }
    }
    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }
    appInformation(){
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                window.webkit.messageHandlers.information.postMessage('1');
            }
        } else {
            if(window.huilian){
                window.huilian.information('1');
            }
        }
    }

    render() {
        let _this = this;
        var {urlOps,statictisData} = this.state; 
        return (
            <div className="informationCollectionListEquipmentBox">
                <div className="blockBox">
                    <h2>设备型号</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>兼容性判断、统计数据</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>兼容性判断时，埋点分析时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>{urlOps.deviceName?'1':'- -'}条</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>{urlOps.deviceName?urlOps.deviceName:'- -'}</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>APP版本</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>更新升级、统计数据</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>判断更新升级时，埋点分析时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>{urlOps.deviceName?'1':'- -'}条</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>{urlOps.versionName?urlOps.versionName:'- -'}</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>IMEI</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>统计数据、支付</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>埋点分析时、支付时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>IMSI</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>统计数据、支付</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>埋点分析时、支付时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>GUID</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>统计数据、支付</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>埋点分析时、支付时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>MAC</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>统计数据、支付</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>埋点分析时、支付时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>WI-FI</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>定位辅助</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>地图定位辅助时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            <div className='right'><p>无</p></div>
                        </div>
                    </div>
                </div>
            </div>
        
                    
                
                
            
        );
    }
}
export default informationCollectionListEquipment;


// WEBPACK FOOTER //
// ./src/informationCollectionList/equipment/index.js